import { watch } from 'vue';
import { useVfm } from 'vue-final-modal';

export default defineNuxtPlugin((nuxtApp) => {
  if (process.server) return;

  const { lockBodyScroll, unlockBodyScroll } = useScrollLock();

  nuxtApp.hook('app:mounted', () => {
    const vfm = useVfm();

    watch(
      () => vfm.openedModals.length,
      (len) => {
        if (len > 0) {
          lockBodyScroll();
        } else {
          unlockBodyScroll();
        }
      },
      { immediate: true },
    );
  });
});
